// extracted by mini-css-extract-plugin
module.exports = {"icons":"ethosIcons-module--icons--vtGIN","icons_inner":"ethosIcons-module--icons_inner--2zfo0"};